import React from 'react';

const PaginationControls = ({ page, totalPages, totalItems, pageSize, onPageChange }) => {
  if (totalPages <= 1) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(totalItems, page * pageSize);

  return (
    <div className="pagination-controls">
      <div className="pagination-info">
        Showing {start}-{end} of {totalItems}
      </div>
      <div className="pagination-buttons">
        <button
          className="pagination-btn"
          type="button"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          Prev
        </button>
        <div className="pagination-page">
          Page {page} of {totalPages}
        </div>
        <button
          className="pagination-btn"
          type="button"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;
